import React, {Component} from 'react';

import {FBShare, ShareIcon} from './icons';
import {FollowButton} from './Follow';
import {colors} from '../../shared/styles';
import shareContent from '../../utils/shareContent';
import { trackGoogleEvent } from '../../utils/googleEvents';
import { styles } from './styles';

/**
 * Components for following and social sharing
 */
export class SocialShare extends Component {

  state = {
    showSocialList: false
  };

  toggleSocialDropDown = (shouldListShow = null) =>
    this.setState({showSocialList: shouldListShow !== null ? shouldListShow : !this.state.showSocialList});

  //TODO: Refine a bit
  getShareType = (url) => {
    const path = url || window.location.href;
    //Order matters as searchEvents is a thing
    if (path.match(/search/)) {
      return 'search';
    }
    else if (path.match(/event/)) {
      return 'event';
    }
    else if (path.match(/athletes/)) {
      return 'profile';
    }
    else {
      return path;
    }
  }

  onClickShare = () => {
    const { isMobile, shareUrl } = this.props;
    const windowLocation = window.location.href;
    const shareIrpUrl = windowLocation.includes(`/Bib/`) ? window.location.href + '?t=' + Date.now() : window.location.href;
    trackGoogleEvent('Social', 'Click', 'Facebook');

    shareContent(shareUrl || shareIrpUrl || window.location.href, isMobile);
  };

  render() {
    const {
      buttonsProps,
      followButton,
      isMobile,
      style = {},
      useFbIcon = false,
    } = this.props;
    const socialToggle =
      isMobile ?
      {
        onClick: () => this.toggleSocialDropDown()
      }
        :
      {
        onMouseEnter: this.toggleSocialDropDown.bind(this, true),
        onMouseLeave: this.toggleSocialDropDown.bind(this, false)
      };

    return (
      <div style={style}>

        {followButton ?
          <Buttons isMobile={isMobile} {...buttonsProps}/>
          : null
        }

        <div
          style={styles.socialShare.shareBtnWrapper(useFbIcon)}
          {...socialToggle}
        >
          <div style={styles.socialShare.socialBtn(useFbIcon)} id="facebook-share">
            {
              useFbIcon &&
                <FBShare
                  size={40}
                  color={colors.facebookBlue}
                  onClick={() => this.onClickShare()}/>
            }
            {!useFbIcon && <ShareIcon onClick={() => this.onClickShare()}/>}
          </div>
        </div>

      </div>
    );
  }
}

/**
 * Prints buttons for athlete profile
 *
 * @param {object} props
 * @return {XML}
 * @constructor
 */
export const Buttons = (props) => {
  const {
    isLoggedIn,
    isFriend,
    athlete: {DisplayName, LogoUrls, City, StateProvAbbrev, CountryID3, RacerID},
    isMobile,
    isMe
  } = props;


  if(isMe) return null;
  else return (
    <FollowButton
      buttonType='rectangle'
      isFriend={isFriend}
      RacerId={RacerID}
      isLoggedIn={isLoggedIn}
      DisplayName={DisplayName}
      Photos={LogoUrls}
      City={City}
      StateProvAbbrev={StateProvAbbrev}
      CountryId3={CountryID3}
      isMobile={isMobile}/>
  );

};



/** WEBPACK FOOTER **
 ** ./components/shared/SocialShare.js
 **/